import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    TelegramShareButton,
    // WhatsappShareButton,
    // PinterestShareButton,
    // VKShareButton,
    // OKShareButton,
    RedditShareButton,
    // TumblrShareButton,
    // LivejournalShareButton,
    // MailruShareButton,
    // ViberShareButton,
    // WorkplaceShareButton,
    // LineShareButton,
    PocketShareButton,
    InstapaperShareButton,
    EmailShareButton,
    FacebookIcon,
    TwitterIcon,
    LinkedinIcon,
    // PinterestIcon,
    // VKIcon,
    // OKIcon,
    TelegramIcon,
    // WhatsappIcon,
    RedditIcon,
    // TumblrIcon,
    // MailruIcon,
    EmailIcon,
    // LivejournalIcon,
    // ViberIcon,
    // WorkplaceIcon,
    // LineIcon,
    PocketIcon,
    InstapaperIcon,
} from 'react-share';
import { Button, Col, Row } from 'antd';
import { logShare } from '../../lib/analyticsEvents';

const spanEach = 3;
export default class AppShareMain extends Component {

    shareAnalytics = (method) => {
        console.dir(method);
        const { type, data } = this.props;
        if (type === 'podcasts') {
            logShare(data.collectionId, 'podcasts', method);
        } else if (type === 'episodes') {
            logShare(data.guid, 'episodes', method);
        }
    }

    render() {
        const { shareUrl, title } = this.props;
        return (
            <div>
                <Row>
                    <Col span={spanEach} onClick={this.shareAnalytics.bind(this, 'facebook')}>
                        <FacebookShareButton
                            url={shareUrl}
                            quote={title}
                            className="Demo__some-network__share-button">
                            <FacebookIcon
                                size={32}
                                round />
                        </FacebookShareButton>
                    </Col>
                    <Col span={spanEach} onClick={this.shareAnalytics.bind(this, 'twitter')}>
                        <TwitterShareButton
                            url={shareUrl}
                            title={title}
                            className="Demo__some-network__share-button">
                            <TwitterIcon
                                size={32}
                                round />
                        </TwitterShareButton>
                    </Col>
                    <Col span={spanEach} onClick={this.shareAnalytics.bind(this, 'telegram')}>
                        <TelegramShareButton
                            url={shareUrl}
                            title={title}
                            className="Demo__some-network__share-button">
                            <TelegramIcon size={32} round />
                        </TelegramShareButton>
                    </Col>
                    <Col span={spanEach} onClick={this.shareAnalytics.bind(this, 'linkedIN')}>
                        <LinkedinShareButton
                            url={shareUrl}
                            windowWidth={750}
                            windowHeight={600}
                            className="Demo__some-network__share-button">
                            <LinkedinIcon
                                size={32}
                                round />
                        </LinkedinShareButton>
                    </Col>
                    <Col span={spanEach} onClick={this.shareAnalytics.bind(this, 'reddit')}>
                        <RedditShareButton
                            url={shareUrl}
                            title={title}
                            windowWidth={660}
                            windowHeight={460}
                            className="Demo__some-network__share-button">
                            <RedditIcon
                                size={32}
                                round />
                        </RedditShareButton>
                    </Col>
                    <Col span={spanEach} onClick={this.shareAnalytics.bind(this, 'email')}>
                        <EmailShareButton
                            url={shareUrl}
                            subject={title}
                            body={`Check out ${title}`}
                            className="Demo__some-network__share-button">
                            <EmailIcon
                                size={32}
                                round />
                        </EmailShareButton>
                    </Col>
                    <Col span={spanEach} onClick={this.shareAnalytics.bind(this, 'pocket')}>
                        <PocketShareButton
                            url={shareUrl}
                            title={title}
                            className="Demo__some-network__share-button">
                            <PocketIcon
                                size={32}
                                round />
                        </PocketShareButton>
                    </Col>
                    <Col span={spanEach} onClick={this.shareAnalytics.bind(this, 'instapaper')}>
                        <InstapaperShareButton
                            url={shareUrl}
                            title={title}
                            className="Demo__some-network__share-button">
                            <InstapaperIcon
                                size={32}
                                round />
                        </InstapaperShareButton>
                    </Col>
                </Row>
            </div>
        )
    }
}

AppShareMain.propTypes = {
    type: PropTypes.any,
    data: PropTypes.any,
    shareUrl: PropTypes.any,
    title: PropTypes.any,
}